import * as React from "react";

const BankIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={20}
    viewBox="0 0 75 75"
    fill="none"
    {...props}
  >
    <path
      d="M37.5 5L70 20H5L37.5 5Z"
      fill={props.color ? props.color : "black"}
    />
    <rect x="12" y="25" width="6" height="35" fill={props.color ? props.color : "black"} />
    <rect x="27" y="25" width="6" height="35" fill={props.color ? props.color : "black"} />
    <rect x="42" y="25" width="6" height="35" fill={props.color ? props.color : "black"} />
    <rect x="57" y="25" width="6" height="35" fill={props.color ? props.color : "black"} />
    <rect x="5" y="65" width="65" height="5" fill={props.color ? props.color : "black"} />
  </svg>
);
export default BankIcon;
